<ng-container *ngIf="label">
    <p-splitButton [label]="label" icon="pi pi-filter" [model]="items">
    </p-splitButton>
</ng-container>